import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// OpenTelemetry is initialized exactly once, by AppComponent.ngOnInit — see
// core/services/telemetry.service.ts. Bootstrapping a second tracer provider
// from here (issue #766) registered the DocumentLoad, Fetch and UserInteraction
// instrumentations twice over, so every span was emitted twice and `fetch` was
// patched twice, and whichever provider registered last silently won the global
// tracer. AppComponent owns the lifecycle because it also owns the shutdown.
bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
